import { DateTime } from 'luxon'

import { queryClient } from '../queryClient'
import type { PagedResult } from '../DTOs/Common/PagedResult'
import type { StoppageCalc } from '../DTOs/Stoppage/StoppageCalc'

const BASE = DateTime.fromISO('1900-01-01', { zone: 'utc' })

// Note: the inverse of computeShiftId (daysSince1900 * 10 + shiftNumber), so a queued change can say
// which shift it belongs to. A sync issue carried only the raw ids, which left the crew deciding a
// conflict with no idea which shift - or which machine - it was about.
export function describeShiftId(shiftId: number | undefined): string | undefined {
  if (!shiftId || !Number.isFinite(shiftId)) return undefined

  const days = Math.floor(shiftId / 10)
  const shiftNumber = shiftId % 10
  const date = BASE.plus({ days })
  if (!date.isValid) return undefined

  const shift = shiftNumber === 1 ? 'Day' : shiftNumber === 2 ? 'Afternoon' : shiftNumber === 3 ? 'Night' : null
  return shift ? `${date.toISODate()} ${shift} shift` : date.toISODate() ?? undefined
}

// Note: the machine's name for a plant id, from whatever the caches know - the Operations list holds
// one row per machine. Used to say which vehicle a queued change is about.
export function cachedMachineName(plantId: number | undefined): string | undefined {
  if (!plantId) return undefined

  for (const [, cached] of queryClient.getQueriesData<PagedResult<StoppageCalc>>({
    queryKey: ['dataTable', 'operations', 'stoppageCalcs'],
  })) {
    for (const row of cached?.data ?? []) {
      if (row?.plantId === plantId && row.machineName) return row.machineName
    }
  }
  return undefined
}
